import API from '~config/api';
import { ApiPromise, DataResponse, ErrorResponse } from '~globals/types';

import { DashboardCarrierStatitics } from './types';

export const DASHBOARD_ENPOINTS = {
  getDashboardCarrierStatitics: '/api/v1/Admin/Report/DashboardCarrier',
};

export const getDashboardCarrierStatitics = (): ApiPromise<
  DataResponse<DashboardCarrierStatitics>,
  ErrorResponse
> =>
  API.post<DataResponse<DashboardCarrierStatitics>, ErrorResponse>(
    DASHBOARD_ENPOINTS.getDashboardCarrierStatitics,
  );
